var _image;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlantaSecado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    enableBackground: "new 0 0 36 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABEVBMVEUAAAAAAAD///+AgIAA AAAAAAAkJCQAAAAgICAAAAAAAAAAAAAzMzMAAAAVFRUAAAAAAAAAAAAAAAAAAAAAAAAQEBAAAAB4 eHjFxcXt7e34+Pj9/f329vbr6+vS0tIPDw9VVVVAQEAAAAAAAAB1dXXp6en7+/vn5+egoKAODg7k 5OTb29saGhoMDAwAAADw8PDw8PDr6+vj4+MSEhIcHByjo6Nubm7m5uZ1dXXHx8f19fUNDQ0qKioA AADV1dURERFxcXHd3d0NDQ0AAAAAAAD////+7sD72XF4Xqj95qH+9+D96rD85qH71WL+89D82XH8 3YH82HH+++/84ZH97sD95aH82XL+8tH83YL94ZL/++8AWZYrAAAARXRSTlMAAQECBAYHCAgFAwIF CQwPEhUWFBMQDCRTm9XxxpxhEQMEBw4ljOONMxJ9cAoVCqqpm34OCTIljSNSxxQGEGAPJG8TCxGA B+Q0AAAAAWJLR0QCZgt8ZAAAAAd0SU1FB+cHCAQ0GB9OthgAAAIdSURBVDjLhZRrV5tAEIZZwp0Q bvFCaDRAQ4xG02psNdpW2y4uRKxNpbf//0O6uyCSBE7fD+SQfc68s8PMMMyKAMMCKqZJbIvjeEGU eEFW1FqMBWpb6+iGaVl2d2tblJVNDKiypu/sOj0XQvdVf8/a1/jBGsZ6fvB66EZ3iOouCkcHujRo VRGW08aHbowqisOjseapFS9ucuwkaE2JY59wpSPwNHMaow0t3tjSoLy5bzgLVKP7twZfpMXKwVGC apWcnvE51Jqdh6hB7rsJzR3I+vuVhNLqHUe6THJXRWsl0AOsersXIoshpbMXVa8EYZWKLjsKdXO+ vfz5CIkeyvfvzpmMId6YVwJBGMckVPIcrTfmAQP8K7cSaEmeyxQH/FEkZQo4c9+Ez8hTQmM94gJh zyK0hSEgllBGDkhKaUqeWQFJxK5b2OGTn5SB6Ff+Q+1sAZeTN3rFN4C/0ZIcRjlKbBGaj69xTu0P eQky+Iemgt2yHPpLSxB4tJi7EUphvdLoY4d0C9AuKjVYV2iK5Auz7U+jrInJhkGbNqeq3TSGCs+1 vM2BHJw2Nd1t4BVdrkqfnfs6ZtHf91vl0M3saU2Tx1NbU15GStGu/jdSmBpIxm24csfMPeyecEx1 0oEiBAfDsBzzJ3d0E0gbO0OVRd3c68/Jwug5lzv6hFeZDQHV87/oX23LPDa2tmey0mJqBfAS80XB v25aYgUG6rbhPwyO1gp/fYcLAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIzLTA3LTA4VDAyOjUyOjI0 KzAyOjAwBVT9ZwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMy0wNy0wOFQwMjo1MjoyNCswMjowMHQJ RdsAAAAASUVORK5CYII="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantaSecado);
export default __webpack_public_path__ + "static/media/PlantaSecado.f6afecb0.svg";
export { ForwardRef as ReactComponent };